/**
 * "mm:ss" com dois dígitos nos dois campos (65 s → "01:05"); fração descartada, negativo vira "00:00".
 *
 * Mora na lib (e não no `AudioMessageBubble`) porque o player e a prévia da resposta (`lib/chat/previaDaResposta.ts`)
 * a usam: a lib não pode depender de um componente de tela (camada invertida), e o `export` de uma função num arquivo
 * de componente reprova a regra `react-refresh/only-export-components`.
 */
export function formatDuration(totalSec: number): string {
  const s = Math.max(0, Math.floor(totalSec));
  const mm = String(Math.floor(s / 60)).padStart(2, "0");
  const ss = String(s % 60).padStart(2, "0");
  return `${mm}:${ss}`;
}
